<template>
  <GlobalNav>
    <div class="login-outer-container">
      <div class="center-middle overflow-container">
        <div class="middle-container">
          <div class="loading-state" v-if="loading">
            <LoadingState :size="50" />
          </div>
          <div v-else>
            <Card :disableTitle="true">
              <div v-if="showLoginMessage" class="p-4">
                <h1 class="container-title">Welcome to the Team!</h1>
                <div class="text-center mb-3">
                  <p>You have successfully joined your new team!</p>
                  <p>Please login to get started.</p>
                </div>
                <div class="text-center">
                  <BtnLink @click="goToLogin">Login</BtnLink>
                </div>
              </div>
              <div v-else class="join-card">
                <Alert :message="error" v-if="error" variant="danger" :dismissible="false" />
                <div class="signup-login-form" v-if="!isLoggedIn">
                  <div class="join-card-top">
                    To join this team, please create a new user or login
                  </div>
                  <JoinLoginComboForm
                    :clientId="Number(clientId)"
                    :code="authToken"
                    :userId="Number(userId)"
                    @success="onSuccess"
                    :longform="true"
                    titleAlignment="center"
                  />
                </div>
                <div class="isloggedin-form" v-if="isLoggedIn">
                  <div class="join-message text-center">
                    You are currently logged in as <strong>{{ user.identity }}</strong
                    >. <br /><br />If you wish to join this account with a different username, log
                    out before continuing.
                  </div>
                  <div class="text-center">
                    <Btn variant="primary" @click="joinLoggedIn" :loading="loadingJoin"
                      >Join Now</Btn
                    >
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </GlobalNav>
</template>

<script>
import { computed, onMounted, ref } from "vue";
import Alert from "@/components/display/Alert.vue";
import Btn from "@/components/display/Btn.vue";
import BtnLink from "@/components/display/BtnLink";
import Card from "@/components/display/Card";
import constants from "@/utils/constants";
import GlobalNav from "@/components/nav/GlobalNav";
import JoinLoginComboForm from "@/components/smart/forms/JoinLoginComboForm";
import LoadingState from "@/components/display/LoadingState";
import router from "@/router";
import store from "@/store";
import { switchClientAction } from "@/utils/switchClient";

export default {
  name: "JoinPage",
  components: {
    Alert,
    Btn,
    BtnLink,
    Card,
    GlobalNav,
    JoinLoginComboForm,
    LoadingState,
  },
  props: {
    userId: String,
    authToken: String,
    clientId: String,
  },
  setup(props) {
    // load token from url
    // check if user is logged in
    //   if user is not logged in, show new custom signup form + toggle to show login form
    //   if user is logged in, show join details

    const loading = ref(false);
    const loadingJoin = ref(false);
    const error = ref(null);
    const isLoggedIn = ref(false);
    const showLoginMessage = ref(false);

    const user = computed(() => {
      return store.state.auth.user;
    });

    const goToLogin = () => router.push({ name: constants.ROUTES.LOGIN });

    const onSuccess = (type) => {
      if (type === "join") {
        const has2Factor = !store.getters["auth/getToken"]?.fullString;
        if (has2Factor) {
          showLoginMessage.value = true;
        } else {
          router.push({ name: constants.ROUTES.HOME });
          fetchUserData();
        }
      } else {
        fetchUserData();
      }
    };

    const fetchUserData = () => {
      // console.log("fetching data for user");
      loading.value = true;
      store
        .dispatch("auth/userInfo")
        .then(() => {
          isLoggedIn.value = true;
          store.dispatch("auth/clientInfo").finally(() => {
            loading.value = false;
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.value = false;
          // error.value = "Cannot fetch user data";
        });
    };

    const joinLoggedIn = () => {
      if (props.userId && props.clientId && props.authToken) {
        loadingJoin.value = true;

        store
          .dispatch("auth/joinWithExistingUser", {
            userId: props.userId,
            clientId: props.clientId,
            code: props.authToken,
          })
          .then(() => {
            // console.log("success join!");
            store
              .dispatch("auth/userInfo")
              .then(() => {
                // isLoggedIn.value = true;
                store.dispatch("auth/clientInfo").finally(() => {
                  // loading.value = false;
                  loadingJoin.value = false;

                  store.dispatch("toasts/addToast", {
                    message: "Successfully joined the team",
                    variant: "success",
                    dismissible: true,
                  });
                  switchClientAction(props.clientId);
                });
              })
              .catch((e) => {
                console.log(e);
                loadingJoin.value = false;
              });
          })
          .catch((e) => {
            // console.log(e);
            error.value = e.response.data[0];
            loadingJoin.value = false;
          });
      } else {
        error.value = "User ID or Client ID or Token are not set.";
      }
      // then launch toast message
      // then redirect to home page
    };

    onMounted(() => {
      if (isLoggedIn.value) {
        fetchUserData();
      }
    });

    return {
      error,
      goToLogin,
      isLoggedIn,
      joinLoggedIn,
      loading,
      loadingJoin,
      onSuccess,
      showLoginMessage,
      user,
    };
  },
};
</script>

<style lang="scss" scoped>
.login-outer-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .overflow-container {
    overflow: auto;
    padding: 1rem 0;
  }
  .middle-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: auto;
    width: 100%;
    max-width: 460px;
    padding: 1rem;
  }
  .loading-state {
    width: 100%;
    min-width: 300px;
    max-width: 350px;
    height: 350px;
    position: relative;
  }

  .join-card {
    padding: 1rem;
    max-width: 460px;

    .join-card-top {
      margin-bottom: 2rem;
      text-align: center;
    }

    .join-message {
      margin-bottom: 2rem;
    }
  }
}
</style>
